import { render, staticRenderFns } from "./yearlyInflationRatesTable.vue?vue&type=template&id=9fc100ea"
import script from "./yearlyInflationRatesTable.vue?vue&type=script&lang=js"
export * from "./yearlyInflationRatesTable.vue?vue&type=script&lang=js"
import style0 from "./yearlyInflationRatesTable.vue?vue&type=style&index=0&id=9fc100ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports